import { gql } from '@apollo/client'

export interface IGetLatestSubmitRequest {
  dealNumber: number
}

export interface IGetLatestSubmitResponse {
  latestSubmitByDeal: {
    id: number
    versionNumber: number
    status: string
    updatedBy?: string
    createdBy: string
    createdDate: string
    updatedDate?: string
  }
}

const GET_LATEST_DEAL_SUBMIT = gql`
  query GetLatestSubmit($dealNumber: Int!) {
    latestSubmitByDeal(dealNumber: $dealNumber) {
      id
      versionNumber
      status
      updatedBy
      createdBy
      createdDate
      updatedDate
    }
  }
`

export default GET_LATEST_DEAL_SUBMIT
